import { Col, Container, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import classNames from 'classnames';
import { createUseThemedStyles } from '@/hooks';

import { ReactComponent as ConsultationsIcon } from '@/assets/icons/hackett-consultations-icon.svg';
import { ReactComponent as ResearchReportsIcon } from '@/assets/icons/hackett-research-reports-icon.svg';
import { ReactComponent as CustomContentIcon } from '@/assets/icons/hackett-custom-content-icon.svg';

const useStyles = createUseThemedStyles({
	iconOuter: {
		width: 160,
		height: 'auto',
		display: 'block',
		margin: '0 auto 8px',
	},
});

export const BpoVendorEnablement = () => {
	const classes = useStyles();

	return (
		<>
			<Helmet>
				<title>Hackett Connect - BPO Vendor Enablement Program</title>
			</Helmet>

			<Container className="bg-white" fluid>
				<Container className="py-11">
					<Row>
						<Col>
							<h1 className="mb-4 text-primary">BPO Vendor Enablement Program</h1>
							<p>
								The BPO Vendor Enablement Program aligns your positioning, capabilities and go-to-market
								approach to what matters most to buyers. Grounded in independent, data-backed insight
								and a clear understanding of how BPO buyers evaluate providers, it clarifies decision
								criteria, sharpens differentiation and strengthens value articulation - improving
								conversion across the sales cycle.
							</p>
							<p className="mb-0">
								By combining objective performance data, competitive intelligence and expert guidance,
								the program drives more effective market engagement and faster deal progression.
							</p>
						</Col>
					</Row>
				</Container>
			</Container>

			<Container className="bg-gray-100" fluid>
				<Container className="py-11">
					<Row className="mb-4">
						<Col>
							<h2 className="mb-4 text-primary">Program Deliverables</h2>
							<p className="mb-0">Members of the BPO Vendor Enablement Program have access to:</p>
						</Col>
					</Row>
					<Row>
						<Col lg={4} className="mb-4">
							<ConsultationsIcon className={classNames(classes.iconOuter, 'text-danger')} />
							<h4 className="mb-2 text-uppercase text-danger text-center">Consultations</h4>
							<p className="mb-0 text-center">
								Regular consultations with The Hackett Group's analysts for guidance on market
								positioning, competitive differentiation, product and service strategy and roadmap
								alignment
							</p>
						</Col>
						<Col lg={4} className="mb-4">
							<ResearchReportsIcon className={classNames(classes.iconOuter, 'text-secondary')} />
							<h4 className="mb-2 text-uppercase text-secondary text-center">Research Reports</h4>
							<p className="mb-0 text-center">
								Relevant research reports, including full versions of Digital World Class&reg; Matix
								reports, process-level best practices and emerging trends
							</p>
						</Col>
						<Col lg={4} className="mb-4">
							<CustomContentIcon className={classNames(classes.iconOuter, 'text-warning')} />
							<h4 className="mb-2 text-uppercase text-warning text-center">Custom Content</h4>
							<p className="mb-0 text-center">
								Vendor profiles showcased on Hackett Connect&reg;, complemented by bespoke thought
								leadership and case studies, with opportunities for targeted engagement through joint
								events and participation in ours
							</p>
						</Col>
					</Row>
				</Container>
			</Container>
		</>
	);
};
